export const DIALOG_TYPE = {
  CONFIRMATION: "CONFIRMATION"
};